module.exports = __webpack_public_path__ + "media/images/emblems/Ruederswil-coat_of_arms-b8abb62de05101d077b1378fe0b4b3b8.svg";